import { Card, List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import { AccountBox, Edit, Delete } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";

type Props = {
  onOpen: (e: React.SyntheticEvent) => void;
  onEditOpportunity: (e: React.SyntheticEvent) => void;
  onDeleteOpportunity: (e: React.SyntheticEvent) => void;
  withEditOpportunity: boolean;
  withDeleteOpportunity: boolean;
};

export function ConsultantOpportunityCardMenu(props: Props) {
  return (
    <Card style={{ padding: 0 }}>
      <List>
        <ListItem button onClick={props.onOpen}>
          <ListItemIcon>
            <AccountBox />
          </ListItemIcon>
          <ListItemText primary={locale.openCard} />
        </ListItem>

        <ListItem
          button
          onClick={props.onEditOpportunity}
          disabled={!props.withEditOpportunity}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>

          <ListItemText primary={locale.Edit} />
        </ListItem>

        {props.withDeleteOpportunity ? (
          <ListItem
            button
            onClick={props.onDeleteOpportunity}
            disabled={!props.withDeleteOpportunity}
          >
            <ListItemIcon>
              <Delete />
            </ListItemIcon>

            <ListItemText primary={locale.Delete} />
          </ListItem>
        ) : null}
      </List>
    </Card>
  );
}
